module.exports = __webpack_public_path__ + "images/vibecode_logo_crm.svg";


//////////////////
// WEBPACK FOOTER
// ./images/vibecode_logo_crm.svg
// module id = 17
// module chunks = 1